import React from 'react';
import Header from "./Header";
import Main from './Main';
import AllUsers from "./AllUsers";
import { Slide, ToastContainer } from "react-toastify";
import UserProfile from "./UserProfile";
import CustomerProfile from "./CustomerProfile";
import RequireLogin from "./RequireLogin";
import Settings from "./Settings/Settings";
import AllCustomers from "./AllCustomers";
import WhiteLabelCustomers from './WhiteLabelCustomers';
import Profile from "./Profile";
import Archived from "./Archived";
import Dashboard from './Dashboard/Dashboard';
import YtHelperDashboard from './YtHelperDashboard';
import UploadVideo from './UploadVideo';
import Notification from './Notification/Notification';
import Rating from './Rating/rating';
import DueCards from './DueCards/DueCards';
import ExportCards from './ExportCards/ExportCards';
import AIToolbox from "./AIToolbox/AIToolbox";
import Inbox from './Inbox/Inbox';
import VideoList from './VideoList/videoList';
import BillingCycle from './BillingCycle/billingCycle';
import PortalManagement from './PortalManagment/portalManagment';
let parentId = localStorage.getItem('parentId');

const parentIdEnabled = (id) => {
    if (id === '0') {
        return true;
    }
    return false;
};

const routes = [
    { path: "/", component: !(parentIdEnabled(parentId)) ? RequireLogin(Main, "home") : RequireLogin(WhiteLabelCustomers) },
    { path: "/cards", component: !(parentIdEnabled(parentId)) ? RequireLogin(Main, "home") : null },
    { path: "/customer/index", component: !(parentIdEnabled(parentId)) ? RequireLogin(Main, "home") : null },
    { path: "/users", component: !(parentIdEnabled(parentId)) ? RequireLogin(AllUsers, "users") : null },
    { path: "/customers", component: !(parentIdEnabled(parentId)) ? RequireLogin(AllCustomers, "customers") : null },
    { path: "/whitelabelcustomers", component: parentIdEnabled(parentId) ? RequireLogin(WhiteLabelCustomers) : null },
    { path: "/user/:userId/profile", component: !(parentIdEnabled(parentId)) ? RequireLogin(UserProfile, "users") : null },
    { path: "/customer/:userId/profile", component: !(parentIdEnabled(parentId)) ? RequireLogin(CustomerProfile, "customers") : null },
    { path: "/settings", component: parentIdEnabled(parentId) ? RequireLogin(Settings) : null },
    { path: "/profile", component: RequireLogin(Profile) },
    { path: "/cards/archive", component: !(parentIdEnabled(parentId)) ? RequireLogin(Archived, "archived") : null },
    { path: "/dashboard", component: !(parentIdEnabled(parentId)) ? RequireLogin(Dashboard, "dashboard") : null },
    { path: "/ythelper/dashboard", component: !(parentIdEnabled(parentId)) ? RequireLogin(YtHelperDashboard, "ytHelper") : null },
    { path: "/upload", component: !(parentIdEnabled(parentId)) ? RequireLogin(UploadVideo, "upload") : null },
    { path: "/notifications", component: RequireLogin(Notification  ) },
    { path: "/rating", component: RequireLogin(Rating, "rating") },
    { path: '/dueCards', component: RequireLogin(DueCards, "dueCards") },
    { path: '/exportCards', component: RequireLogin(ExportCards, "exportCards") },
    { path: '/AIToolbox', component: RequireLogin(AIToolbox, "AIToolbox") },
    { path: '/inbox', component: RequireLogin(Inbox, "inbox") },
    { path: "/videosList", component: RequireLogin(VideoList, "videosList") },
    { path: "/billingCycle", component: RequireLogin(BillingCycle, "billingCycle") },
    { path: "/portalManagement", component:RequireLogin(PortalManagement, "portalManagement")},
];

export default routes;
